const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Treffen Sie hier Ihre Wahl.",
  seeAll: "Alle anzeigen",
  clear: "Löschen",
  back: "Zurück",
  save: "Speichern",
  close: "Schließen",
  of: "Von",
  to: "Bis",
  copyrights: "© {date} Bridgestone Solutions. Alle Rechte vorbehalten.",
  pageNotFound: "Seite nicht gefunden",
  accessDenied: "Zugriff verweigert",
  search: "Suche",
  year: "Jahr",
  buttons: {
    loading: "Laden...",
    export: "Exportieren",
    delete: "Löschen",
    save: "Speichern",
    cancel: "Abbrechen",
    next: "Weiter",
    back: "Zurück",
    skip: "Überspringen",
    send: "Senden",
    pointsList: "Punkteliste",
    clear: "Löschen",
    readNow: "Jetzt lesen",
    more: "Mehr",
    close: "Schließen",
    reportError: "Fehler melden",
    accept: "Akzeptieren",
    download: "Herunterladen",
    downloadAll: "Alles herunterladen",
    dealerInfoDownload: "HERUNTERLADEN",
    toTheBasket: "In den warenkorb",
    toOrderDelivery: "Weiter zur Lieferadresse",
    discover: "Entdecken",
    newAddress: "Neue lieferadresse erstellen",
    selectAddressBtn: "Adresse auswählen",
    toOrderSummary: "Zur Bestellübersicht",
    placeOrder: "Verbindlich Bestellen",
    toDashboard: "Zur Startseite",
    newOrder: "Neue Bestellung",
    userOrders: "Meine Bestellungen",
    toSearch: "Suchen",
    select: "Auswählen",
    moreCustomerNumbers: "+ WEITERE KUNDENZAHLEN HINZUFÜGEN",
    loadMore: "Weitere umsätze laden",
    toStaffDashboard: "Zum Dashboard",
    toQuiz: "Zum Quiz",
    vouchers: "Gutscheine",
    exchangeVoucher: "Gutscheincode einlösen",
    confirm: "Bestätigen",
    clearFilters: "Filter zurücksetzen",
    selectAll: "Alles auswählen",
    downloadSelection: "Auswahl herunterladen",
    deselectAll: "Auswahl aufheben",
    setFilters: "Bitte setzen Sie Ihre Auswahlfilter",
    sharePoints: "Punkte teilen",
    create: "Erstellen",
    update: "Aktualisieren",
    directBuy: "Direkt bestellen",
    sendRequest: "Anfrage senden",
    showAllProducts: "Zum Prämienshop",
    reset: "Neue Berechnung",
    calculate: "Berechnen",
    toBDrive: "Zu B-Drive",
    preview: "Vorschau",
    clickHere: "Details ansehen",
    all: "Alle",
  },
  tooltips: {
    info: "Brauchen Sie Hilfe? +43 1 6141388",
  },
  confirmation: {
    header: "Bestätigung erforderlich",
    message: "Möchten Sie diesen Eintrag löschen?",
  },
  nav: {
    consents: "Einwilligungen",
    dashboard: "Startseite",
    accountDashboard: "Startseite",
    account: "Mein Konto",
    mailbox: "Posteingang",
    singleMailbox: "Nachrichten",
    stammdaten: "Stammdaten",
    news_feeds: "Aktuelles",
    pointsOverview: "Punkteübersicht",
    rewardsOverview: "Punkteübersicht",
    about: 'Über Bridgestone <span class="text-danger">Plus</span>',
    service_number: "Kontakt & Service",
    shop: "Prämienshop",
    salesPromotions: "Verkaufsförderung",
    promotions: "Mein Konto",
    shopCategory: "Prämienshop",
    productDetails: "Produktdetails",
    userOrders: "Benutzerbestellungen",
    shoppingCart: "Warenkorb",
    orderDelivery: "Lieferadresse",
    orderSummary: "Bestellübersicht",
    orderComplete: "Bestellung abgeschlossen",
    text_page: "Statische Seite",
    staff: "Service Dashboard",
    onlineTrainings: "Online Trainings",
    trainings: "Schulungen",
    training: "Schulung",
    trainingForm: "Schulungsformular",
    staffVouchers: "Gutscheine",
    wholesalerVouchers: "Gutscheine",
    brochure_prices: "Produktbroschüren & Preislisten",
    investment: "Investitionsunterstuetzung",
    media: "Produktinformationen & Medien",
    medias: "Produkte & Medien",
    preislisten: "Produktinformationen",
    pricat: "Pricat",
    wholesaler: "Händler-Dashboard",
    contact_service: "Kontakt & Service",
    sales_support: "Verkaufsunterstützung",
    onlineVisibility: "Uberall",
    productInfo: "Produktinformationen",
    fuelCalculator: "Spritspar-Rechner",
    bridgestoneSchulungen: "Bridgestone Schulungen",
    externeTraining: "Externe Schulungen",
    favoriteProducts: "Lieblingsprodukte",
    bridgestoneSingleSchulungen: "Bridgestone Schulungen Training",
    preislistenList: "Preislisten",
    bDrive: "Produkt-Abbildungen",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Teilnahmebedingungen",
    first_stop: "Bridgestone Reifengarantie",
    payouts: "Payouts",
  },
  breadcrumbs: {
    dashboard: "Startseite",
    accountDashboard: "Startseite",
    account: "Mein Konto",
    mailbox: "Posteingang",
    singleMailbox: "Nachrichten",
    stammdaten: "Stammdaten",
    news_feeds: "Aktuelles",
    pointsOverview: "Punkteübersicht",
    rewardsOverview: "Punkteübersicht",
    about: 'Über Bridgestone <span class="text-danger">Plus</span>',
    service_number: "Kontakt & Service",
    shop: "Prämienshop",
    salesPromotions: "Verkaufsförderung",
    promotions: "Mein Konto",
    shopCategory: "Prämienshop",
    productDetails: "Produktdetails",
    userOrders: "Benutzerbestellungen",
    shoppingCart: "Warenkorb",
    orderDelivery: "Lieferadresse",
    orderSummary: "Bestellübersicht",
    orderComplete: "Bestellung abgeschlossen",
    staff: "Service Dashboard",
    onlineTrainings: "Online Trainings",
    trainings: "Schulungen",
    training: "Schulung",
    trainingForm: "Schulungsformular",
    staffVouchers: "Gutscheine",
    wholesalerVouchers: "Gutscheine",
    brochure_prices: "Produktbroschüren & Preislisten",
    investment: "Investitionsunterstuetzung",
    media: "Produktinformationen & Medien",
    medias: "Produkte & Medien",
    preislisten: "Produktinformationen",
    pricat: "Pricat",
    wholesaler: "Händler-Dashboard",
    contact_service: "Kontakt & Service",
    sales_support: "Verkaufsunterstützung",
    onlineVisibility: "Uberall",
    productInfo: "Produktinformationen",
    fuelCalculator: "Spritspar-Rechner",
    bridgestoneSchulungen: "Bridgestone Schulungen",
    externeTraining: "Externe Schulungen",
    favoriteProducts: "Lieblingsprodukte",
    bridgestoneSingleSchulungen: "Bridgestone Schulungen Training",
    preislistenList: "Preislisten",
    bDrive: "Produkt-Abbildungen",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Teilnahmebedingungen",
    first_stop: "Bridgestone Reifengarantie",
    payouts: "Payouts",
  },
  menu: {
    account: "Mein Konto",
    plus: 'Über Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Vertriebsunterstützung",
    mailbox: "Posteingang",
    about: 'Über Bridgestone <span class="text-danger">Plus</span>',
    trainingAndCourses: "Schulungen und Kurse",
    externalTraining: "Externe Schulungen",
    productInfo: "Produktinformationen",
    productBrochures: "Produktbroschüren",
    priceLists: "Preislisten",
    price: "Preis",
    complaintForm: "Beschwerdeformular",
    sales_support: "Vertriebsunterstützung",
    contact_service: "Kontakt & Service",
    logOut: "Abmelden",
    news: "Aktuelles",
    news_feeds: "Aktuelles",
    service_number: "Kontakt & Service",
    salesPromotions: "Verkaufsförderung",
    shop: "Prämienshop",
    onlineTrainings: "Online Trainings",
    trainings: "Schulungen",
    stammdaten: "Stammdaten",
    brochure_prices: "Produktbroschüren & Preislisten",
    media: "Preislisten",
    medias: "Produkte & Medien",
    onlineVisibility: "Uberall",
    preislisten: "Produktinformationen",
  },
  validation: {
    requiredField: "Pflichtfeld",
  },
  sortBy: {
    default: "Sortieren nach",
    desc: "Sortieren nach: Neueste",
    asc: "Sortieren nach: Älteste",
    name: "Namen",
    date: "Datum",
    choiceBy: "Sortieren",
  },
  month: {
    1: "Januar",
    2: "Februar",
    3: "März",
    4: "April",
    5: "Mai",
    6: "Juni",
    7: "Juli",
    8: "August",
    9: "September",
    10: "Oktober",
    11: "November",
    12: "Dezember",
  },
};

export default {
  messages,
};
